import { render, staticRenderFns } from "./student_detail.vue?vue&type=template&id=5a15502a&scoped=true"
import script from "./student_detail.vue?vue&type=script&lang=js"
export * from "./student_detail.vue?vue&type=script&lang=js"
import style0 from "./student_detail.vue?vue&type=style&index=0&id=5a15502a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a15502a",
  null
  
)

export default component.exports